import { Tab } from '../../types'

export const verifyOrderTabs: Tab[] = [
  { id: 'customer', label: 'Customer' },
  { id: 'rate', label: 'Rate' },
  { id: 'pickup', label: 'Pickup' },
  { id: 'delivery', label: 'Delivery' },
  { id: 'notes', label: 'Notes' },
]
